import PollyFills from './PollyFills';

export default PollyFills;
